<template>
  <BasePopup
    :visible="visible"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="team-list-popup"
    @close="handleClose"
  >
    <div class="v3-popup-content-content">
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>身份</th>
              <th>成員</th>
              <th>入隊時間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(member, index) in teamMembers" :key="index">
              <td>{{ member.role }}</td>
              <td>{{ member.name }}</td>
              <td>{{ member.joinTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </BasePopup>
</template>

<script setup>
import { watch } from 'vue';
import { point } from "@/utils";
import BasePopup from './BasePopup.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  teamMembers: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:visible', 'close']);

// 监听弹窗状态，打点上报
watch(
  () => props.visible,
  (value) => {
    if (value) {
      point({
        eventName: 'show_popup',
        eventType: '组队列表弹窗'
      });
    }
  }
);

const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};
</script>

<style scoped lang="less">
</style>
